import { useLayoutEffect, useState } from "react"
import NickNameCreateAndUpdateModal from "../my/setting/ui/nickNameCreateAndUpdateModal";
import { useGetNickNameDetailWeb } from "../my/setting/model";
import { useNavigate } from "react-router-dom";

const SignIn = () => {
    const { data, isFetching } = useGetNickNameDetailWeb();
    const [open, setOpen] = useState<boolean>(false);
    const navigate = useNavigate()

    useLayoutEffect(() => {
        if (isFetching) return;
        if (data?.id == undefined) {
            setOpen(data?.id == undefined)
        } else {
            navigate('/')
        }

    }, [isFetching])
    return <>
        <NickNameCreateAndUpdateModal open={open} setOpen={setOpen} title="회원가임" leftIcon='none' isShowSaveBtn saveBtntext="가입 완료" description="닉네임을 입력해 주세요" classNames={{ description: 'sub-title/st3' }} />
    </>
}

export { SignIn }